import { render, staticRenderFns } from "./NotSubscribedNow.vue?vue&type=template&id=19b4b4f2&scoped=true&"
import script from "./NotSubscribedNow.vue?vue&type=script&lang=ts&"
export * from "./NotSubscribedNow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b4b4f2",
  null
  
)

export default component.exports